import React from 'react';

interface Props {
  title: string;
  disableDivider?: boolean;
  className?: string;
}

const FormSectionHeader: React.FC<Props> = ({
  title,
  className = 'mb-2',
  disableDivider
}) => {
  return (
    <h2
      data-testid="form-section-header"
      className={`text-base font-semibold text-neutral-70 flex items-center ${className}`}
    >
      <span className="pr-2 uppercase">{title}</span>
      {disableDivider ? null : (
        <span className="section-divider h-px bg-neutral-30 flex-1" />
      )}
    </h2>
  );
};

export default FormSectionHeader;
